import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./App.css";

import Login from "./pages/login/Login";
import Dashboard from "./pages/dashboard/Dashboard";
import Unauthorized from "./pages/unauthorized/Unauthorized";
import UserManagement from "./pages/userManagement/UserManagement";

import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import Projects from "./pages/projectManagement/ProjectsPackagesTasksWrapper";
import Meeting from "./pages/meeting/Meeting";
import ResourceAllocation from "./pages/resourceAllocation/ResourceAllocation";
import Notification from "./pages/notification/Notification";
import ForgotPassword from "./pages/forgotPassword/forgotPassword";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import ResetPassword from "./pages/resetPassword/resetPassword";
import PrivacyPolicy from "./components/PrivacyPolicy";

ChartJS.register(ArcElement, Tooltip, Legend);

const router = createBrowserRouter([
  {
    path: "/",
    element: <Login />,
  },
  { path: "/privacy-policy", element: <PrivacyPolicy /> },
  { path: "/forgot-password", element: <ForgotPassword /> },
  { path: "/reset-password/:token", element: <ResetPassword /> },
  { path: "/unauthorized", element: <Unauthorized /> },
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        element: (
          <ProtectedRoute
            allowedRoles={[
              "superadmin",
              "manager",
              "assistant superadmin",
              "staff",
              "auditor",
            ]}
          />
        ),
        children: [{ path: "/dashboard", element: <Dashboard /> }],
      },
      {
        element: (
          <ProtectedRoute
            allowedRoles={[
              "superadmin",
              "manager",
              "assistant superadmin",
              "staff",
              "auditor",
            ]}
          />
        ),
        children: [{ path: "/user-management", element: <UserManagement /> }],
      },
      {
        element: (
          <ProtectedRoute
            allowedRoles={["superadmin", "assistant superadmin", "auditor"]}
          />
        ),
        children: [
          { path: "/resource-allocation", element: <ResourceAllocation /> },
        ],
      },
      {
        element: (
          <ProtectedRoute
            allowedRoles={[
              "superadmin",
              "manager",
              "assistant superadmin",
              "staff",
              "auditor",
            ]}
          />
        ),
        children: [{ path: "/project-management", element: <Projects /> }],
      },
      {
        element: (
          <ProtectedRoute
            allowedRoles={[
              "superadmin",
              "manager",
              "assistant superadmin",
              "staff",
              "auditor",
            ]}
          />
        ),
        children: [{ path: "/meeting", element: <Meeting /> }],
      },
      {
        element: (
          <ProtectedRoute
            allowedRoles={[
              "superadmin",
              "manager",
              "assistant superadmin",
              "staff",
              "auditor",
            ]}
          />
        ),
        children: [{ path: "/notifications", element: <Notification /> }],
      },
    ],
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
